<template>
    <v-dialog v-model="dialog" width="600" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-date-input
                                v-model="monitoring_date"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                label="Monitoring Date"
                            ></v-date-input>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="agenda"
                                :rules="[formRules.required]"
                                label="Agenda"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            monitoring_date: null,
            semester_schoolyear_id: null,
            agenda: null,
        }
     },
     methods: {
        initAdd(){
            this.dialog = true
            this.dialog_title = 'Recommendation & Compliance Matrix'
            this.dialog_sub_title = 'Add new recommending & compliance matrix information'
            this.action = 'add'
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Recommendation & Compliance Matrix'
            this.dialog_sub_title = 'Update recommending & compliance matrix information'
            this.action = 'edit'

            this.id = data.id
            this.monitoring_date = data.monitoring_date
            this.semester_schoolyear_id = data.semester_schoolyear_id
            this.agenda = data.agenda
        },
        getItemTitle(item) {
            return `${item.fname} ${item.mname ? item.mname[0] + '.' :''} ${item.lname}${item.suffix ? ', ' + item.suffix : ''}` ;
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    monitoring_date: this.monitoring_date,
                    semester_schoolyear_id: this.$store.state.semester_schoolyear.id,
                    agenda: this.agenda,
                }

                if(this.action == 'add'){
                    let res = await this.axiosCall('/compliance-matrix', 'post', formData, true)
                    if(res.data.status == 200){
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('AMS Form successfully added!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }
                else if(this.action == 'edit'){
                    let res = await this.axiosCall('/compliance-matrix/' + this.id, 'patch', formData, true)
                    if(res.data.status == 200){
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('AMS Form successfully updated!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.$emit('refresh')
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>